import { Grid } from '@mui/material'
import PrescriptionSectionCard from './PrescriptionSectionCard'
import MarginEditor from './MarginEditor'

/**
 * Section for custom page margins configuration
 * Displays visual margin editor with input fields for all four sides
 */
export default function CustomMarginsSection({
  prescriptionTemplate,
  handleChangeMargins,
  defaultMargins = {},
  disabled,
}) {
  return (
    <PrescriptionSectionCard heading="Page Margins (in inches)">
      <Grid item xs={12} sx={{ justifyContent: 'center', display: 'flex' }}>
        <MarginEditor
          defaultMargins={defaultMargins}
          margins={prescriptionTemplate?.margins}
          onChange={handleChangeMargins}
          disabled={disabled}
          editMode="viewPopover"
        />
      </Grid>
    </PrescriptionSectionCard>
  )
}
